import * as authPopup from '@/auth/authPopup'
import {callApi} from '@/shared/ApiHelper'
import {EventType} from '@azure/msal-browser'
import {useApiStore} from '@/store/api.js'

const apiStore = useApiStore()
const B2CStaffProviders = [
    'https://login.microsoftonline.com/34408998-73b4-4544-b57e-bbad0a3cd855/v2.0', // PaTTAN West
    'https://login.microsoftonline.com/7a6f63a3-7ba6-4e6d-b5db-e193e5b4bd49/v2.0', // PaTTAN Central
    'https://login.microsoftonline.com/db3429d1-64b8-4c56-89e2-33d3801721d8/v2.0', // PaTTAN East
]

authPopup.msalAgent.addEventCallback((message) => {
    if (message.eventType == EventType.LOGIN_SUCCESS || message.eventType == EventType.LOGOUT_SUCCESS) {
        checkForSignIn(apiStore.baseUrl)
        // Workaround for a bug where some async part of the sign in process never resolves, sometimes preventing sign out
        if (message.eventType == EventType.LOGIN_SUCCESS) {
            window.location = window.location.href
        } 
    }
})

export const checkForSignIn = async function (redirectUri) {
    let oid = null
    const accounts = authPopup.msalAgent.getAllAccounts()
    if (0 < accounts.length) {
        oid = accounts[0].localAccountId
        apiStore.oid = oid

        const hasToken = await authPopup.passTokenToApi(redirectUri).catch((error) => console.error(error))
        if (hasToken) {
            console.log('Access token acquired (susiHelper)')
        }

        await setSignInLink('Sign out',  null, authPopup.signOut, true)
        if (undefined === accounts[0].idTokenClaims.idp) {
            apiStore.isStaff = false
        } else {
            apiStore.isStaff = B2CStaffProviders.includes(accounts[0].idTokenClaims.idp.toLowerCase())
        }
    } else {
        await setSignInLink('Sign in/Sign up', 'Not signed in', authPopup.signIn, false)
        apiStore.displayName = null
        apiStore.isStaff = false
        apiStore.oid = null
    }

    return oid
}

export const reloadAttendee = async function() {
    if (apiStore.oid) {
        const apiResponse = await callApi(apiStore.buildUrl('/events/attendees/?a=' + apiStore.oid), 'GET', {}, true)
        if (apiResponse) {
            const attendee = apiResponse.data[0]
            if (attendee.is_active) {
                apiStore.currentAttendee = attendee
                apiStore.displayName = attendee.display_name
            } else {
                authPopup.signOut()
            }
        }
    }
}

export const setDisplayName = async function (displayName, email = null) {
    if (undefined == displayName || undefined == email || null == email) {
        if (apiStore.displayName) {
            displayName = apiStore.displayName
            email = apiStore.currentAttendee.registration_email_address
        } else {
            if (apiStore.oid) {
                try {
                    await reloadAttendee()
                    if (apiStore.currentAttendee) {
                        displayName = apiStore.currentAttendee.display_name
                        email = apiStore.currentAttendee.registration_email_address
                    }
                } catch(exception) {
                    console.warn(exception)
                    apiStore.displayName = null
                    const accounts = authPopup.msalAgent.getAllAccounts()
                    if (0 < accounts.length) {
                        apiStore.displayName = accounts[0].idTokenClaims['name']
                    }
                }
            }
        }
    } else {
        apiStore.displayName = displayName
    }

    if (undefined == displayName) {
        displayName = 'Not signed in'
        email = null
    } else {
        apiStore.displayName = displayName
    }
    document.querySelector('#accountNameText').textContent = displayName
    document.querySelector('#accountEmailText').textContent = email
}

async function setSignInLink(linkText, displayName, clickHandler, isSignOut, email = null) {
    document.querySelector('.loginLinkText').textContent = linkText
    document.querySelector('.loginLink').addEventListener('click', clickHandler)
    await setDisplayName(displayName, email)
    if (isSignOut) {
        document.querySelector('#accountLinks').style.display = 'block'
    } else {
        document.querySelector('#accountLinks').style.display = 'none'
    }
}

export const setSignOutLink = async function() {
    await setSignInLink('Sign out', apiStore.displayName, authPopup.signOut, true, apiStore.currentAttendee.registration_email_address)
}
